/**
 * The resolved version string baked into the bundle at build time via the Vite `define` in
 * `vite.config.ts`. Falls back to `"unknown"` when the constant was not injected (e.g. under the
 * test runner).
 */
export function getAppVersion(): string {
  return typeof __APP_VERSION__ === "undefined" ? "unknown" : __APP_VERSION__
}
